import UpcomingUserAppointments from "../models/domain/UpcomingUserAppointment";
import AppointmentMapper from "./AppointmentMapper";

export default class UpcomingUserAppointmentMapper {
  static mapResponseToModel(response: any): UpcomingUserAppointments {
    return new UpcomingUserAppointments(
      response.appointment
        ? AppointmentMapper.mapResponseToModel(response.appointment)
        : null,
    );
  }
}
